// // src/pages/QuestionAnswersPage.js
// import { useEffect, useMemo, useState } from "react";
// import { Link, useSearchParams } from "react-router-dom";
// import { useExperiences } from "../context/ExperiencesContext";
// import ScoreVisualizations from "../components/answers/ScoreVisualizations";
// import "./QuestionAnswersPage.scss";

// function safeDate(ts) {
//   if (!ts) return null;
//   const d = new Date(ts);
//   if (Number.isNaN(d.getTime())) return null;
//   return d;
// }

// function formatDate(d) {
//   if (!d) return "—";
//   return d.toLocaleDateString(undefined, {
//     month: "2-digit",
//     day: "2-digit",
//     year: "numeric",
//   });
// }

// function formatTime(d) {
//   if (!d) return "";
//   return d.toLocaleTimeString(undefined, {
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

// function splitTopics(t) {
//   if (!t) return [];
//   if (Array.isArray(t)) return t.map(String).filter(Boolean);
//   return String(t)
//     .split(/[,|]/g)
//     .map((s) => s.trim())
//     .filter(Boolean);
// }

// function scoreBubbleTone(score, isBlank) {
//   if (isBlank) return "qaScoreBubble qaToneBlank";
//   const s = Number(score || 0);
//   if (s < 40) return "qaScoreBubble qaToneLow";
//   if (s < 70) return "qaScoreBubble qaToneMid";
//   return "qaScoreBubble qaToneHigh";
// }

// export default function QuestionAnswersPage() {
//   const [params] = useSearchParams();
//   const insightId = params.get("insightId") || "";
//   const q = params.get("q") || "";

//   const { assessments, assessmentsLoading } = useExperiences();

//   const [hideBlank, setHideBlank] = useState(true);
//   const [search, setSearch] = useState("");
//   const [expanded, setExpanded] = useState(() => new Set());
//   const [selectedBin, setSelectedBin] = useState(null);
//   const BIN_SIZE = 20;

//   // Scroll to top when component mounts or question changes
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [insightId, q]);

//   const toggleExpanded = (key) => {
//     setExpanded((prev) => {
//       const next = new Set(prev);
//       if (next.has(key)) next.delete(key);
//       else next.add(key);
//       return next;
//     });
//   };

//   const getAnswerText = (r) =>
//     (r.answer || r.transcript || r.studentAnswer || "").toString().trim();

//   const getScoreNumber = (r) => {
//     const n = Number(r.score);
//     return Number.isFinite(n) ? n : null;
//   };

//   // Match by question text (workaround until backend pagination fix is deployed)
//   const rows = useMemo(() => {
//     if (!assessments || !Array.isArray(assessments) || !q) {
//       return [];
//     }

//     const questionText = decodeURIComponent(q);

//     // Match by question text
//     const filtered = assessments.filter((a) => {
//       const assessmentQuestion = a.question || "";
//       // Exact match
//       if (assessmentQuestion === questionText) return true;
//       // Prefix match (first 50 chars)
//       if (assessmentQuestion.slice(0, 50) === questionText.slice(0, 50)) return true;
//       // Normalized match
//       const normalizedAssessment = assessmentQuestion.replace(/\s+/g, " ").trim();
//       const normalizedQuestion = questionText.replace(/\s+/g, " ").trim();
//       if (normalizedAssessment.slice(0, 50) === normalizedQuestion.slice(0, 50)) return true;
//       return false;
//     });

//     return filtered
//       .map((a) => ({
//         timestamp: a.lastModified || a.createdAt || "",
//         score: Number(a.score ?? 0),
//         answer: (a.studentAnswer ?? a.transcript ?? "").toString(),
//         transcript: (a.studentAnswer ?? a.transcript ?? "").toString(),
//         summary: a.summary ?? "",
//         feedback: a.aiResponse ?? a.student_evaluation ?? "",
//         topics: a.topics ?? "",
//         environmentId: a.environmentId ?? null,
//         sessionCode: a.sessionCode ?? a.assessmentId ?? null,
//         experienceId: a.experienceId ?? null,
//       }))
//       .sort((a, b) => String(b.timestamp).localeCompare(String(a.timestamp)));
//   }, [assessments, q]);

//   const loading = assessments === null || assessmentsLoading;

//   const avgScore = useMemo(() => {
//     if (!rows.length) return null;
//     const scored = rows.map((r) => getScoreNumber(r)).filter((n) => typeof n === "number");
//     if (!scored.length) return null;
//     return Math.round(scored.reduce((a, b) => a + b, 0) / scored.length);
//   }, [rows]);

//   const blankCount = useMemo(() => rows.filter((r) => !getAnswerText(r)).length, [rows]);

//   const filtered = useMemo(() => {
//     return rows.filter((r) => {
//       const ans = getAnswerText(r);
//       const score = getScoreNumber(r);

//       if (hideBlank && !ans) return false;
//       if (selectedBin && score != null) {
//         const inBin = score >= selectedBin.min && (score < selectedBin.max || (selectedBin.max === 100 && score === 100));
//         if (!inBin) return false;
//       }
//       if (search && !ans.toLowerCase().includes(search.toLowerCase())) return false;
//       return true;
//     });
//   }, [rows, hideBlank, search, selectedBin]);

//   return (
//     <div className="qaPage">
//       <div className="qaContainer">
//         <Link className="qaBackLink" to="/">
//           ← Back to Dashboard
//         </Link>

//         <div className="qaHeader">
//           <div className="qaHeaderId">Insight ID {insightId || "—"}</div>
//           <div className="qaHeaderQuestion">{q || "(no question provided)"}</div>
//         </div>

//         <div className="qaSection">
//           <div className="qaSectionBody">
//             <ScoreVisualizations
//               rows={rows}
//               getAnswerText={getAnswerText}
//               getScoreNumber={getScoreNumber}
//               selectedBin={selectedBin}
//               setSelectedBin={setSelectedBin}
//               binSize={BIN_SIZE}
//               avgScore={avgScore}
//               blankCount={blankCount}
//             />
//           </div>
//         </div>

//         <div className="qaSection">
//           <div className="qaSectionTitle">Responses ({rows.length} total)</div>

//           <div className="qaToolbar">
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               className="qaSearch"
//               placeholder="Search"
//             />
//             <button
//               className="qaPill qaBlankToggle"
//               onClick={() => setHideBlank((v) => !v)}
//               type="button"
//               aria-pressed={hideBlank}
//             >
//               {hideBlank ? "SHOW BLANKS" : "HIDE BLANKS"}
//             </button>
//           </div>

//           {loading ? (
//             <div className="qaEmpty">Loading answers…</div>
//           ) : rows.length === 0 ? (
//             <div className="qaEmpty">
//               No responses found for this question.
//             </div>
//           ) : (
//             <div className="qaTable">
//               <div className="qaTableHeader">
//                 <div className="qaTh">DATE</div>
//                 <div className="qaTh">NAME</div>
//                 <div className="qaTh">SCORE</div>
//                 <div className="qaTh">ANSWER</div>
//                 <div className="qaTh qaThAction" />
//               </div>

//               {filtered.map((r, idx) => {
//                 const key = `${r.timestamp || ""}-${r.sessionCode || ""}-${idx}`;
//                 const isOpen = expanded.has(key);
//                 const answer = getAnswerText(r);
//                 const isBlank = !answer;
//                 const d = safeDate(r.timestamp);
//                 const topics = splitTopics(r.topics);
//                 const hasDetails = Boolean(r.summary || r.feedback || topics.length);

//                 return (
//                   <div key={key} className="qaTr">
//                     <div className="qaTd qaTdDate">
//                       <div className="qaDateMain">{formatDate(d)}</div>
//                       <div className="qaDateSub">{formatTime(d)}</div>
//                     </div>
//                     <div className="qaTd qaTdName">
//                       <div className="qaNameSub">Anonymous</div>
//                       <div className="qaNameMain">{r.sessionCode || "—"}</div>
//                     </div>
//                     <div className="qaTd qaTdScore">
//                       <div className={scoreBubbleTone(r.score, isBlank)}>
//                         {isBlank ? "—" : `${Math.round(r.score || 0)}%`}
//                       </div>
//                     </div>
//                     <div className="qaTd qaTdAnswer">
//                       <div className={`qaAnswer ${isBlank ? "isBlank" : ""}`}>
//                         {answer || "No response provided"}
//                       </div>
//                       {hasDetails && isOpen && (
//                         <div className="qaDetails">
//                           {r.summary && (
//                             <div className="qaDetailBlock">
//                               <div className="qaDetailLabel">SUMMARY</div>
//                               <div className="qaDetailText">{r.summary}</div>
//                             </div>
//                           )}
//                           {r.feedback && (
//                             <div className="qaDetailBlock">
//                               <div className="qaDetailLabel">AI FEEDBACK</div>
//                               <div className="qaDetailText">{r.feedback}</div>
//                             </div>
//                           )}
//                           {topics.length > 0 && (
//                             <div className="qaDetailBlock">
//                               <div className="qaDetailLabel">TOPICS</div>
//                               <div className="qaTopics">
//                                 {topics.map((t) => (
//                                   <span key={t} className="qaTopic">{t}</span>
//                                 ))}
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                     <div className="qaTd qaTdAction">
//                       {hasDetails ? (
//                         <button
//                           className={`qaPill ${isOpen ? "isActive" : ""}`}
//                           type="button"
//                           onClick={() => toggleExpanded(key)}
//                         >
//                           {isOpen ? "HIDE" : "VIEW"}
//                         </button>
//                       ) : (
//                         <div className="qaNoAction">—</div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}

//               {filtered.length === 0 && (
//                 <div className="qaEmpty">No results match your filters.</div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // src/pages/QuestionAnswersPage.js
// import { useEffect, useMemo, useState } from "react";
// import { Link, useSearchParams } from "react-router-dom";
// import { useExperiences } from "../context/ExperiencesContext";
// import ScoreVisualizations from "../components/answers/ScoreVisualizations";
// import "./QuestionAnswersPage.scss";

// function safeDate(ts) {
//   if (!ts) return null;
//   const d = new Date(ts);
//   if (Number.isNaN(d.getTime())) return null;
//   return d;
// }

// function formatDate(d) {
//   if (!d) return "—";
//   return d.toLocaleDateString(undefined, {
//     month: "2-digit",
//     day: "2-digit",
//     year: "numeric",
//   });
// }

// function formatTime(d) {
//   if (!d) return "";
//   return d.toLocaleTimeString(undefined, {
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

// function splitTopics(t) {
//   if (!t) return [];
//   if (Array.isArray(t)) return t.map(String).filter(Boolean);
//   return String(t)
//     .split(/[,|]/g)
//     .map((s) => s.trim())
//     .filter(Boolean);
// }

// function scoreBubbleTone(score, isBlank) {
//   if (isBlank) return "qaScoreBubble qaToneBlank";
//   const s = Number(score || 0);
//   if (s < 40) return "qaScoreBubble qaToneLow";
//   if (s < 70) return "qaScoreBubble qaToneMid";
//   return "qaScoreBubble qaToneHigh";
// }

// export default function QuestionAnswersPage() {
//   const [params] = useSearchParams();
//   const insightId = params.get("insightId") || "";
//   const q = params.get("q") || "";

//   const { assessments, assessmentsLoading } = useExperiences();

//   const [hideBlank, setHideBlank] = useState(true);
//   const [search, setSearch] = useState("");
//   const [expanded, setExpanded] = useState(() => new Set());
//   const [selectedBin, setSelectedBin] = useState(null);
//   const BIN_SIZE = 20;

//   // Scroll to top when component mounts or question changes
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [insightId, q]);

//   const toggleExpanded = (key) => {
//     setExpanded((prev) => {
//       const next = new Set(prev);
//       if (next.has(key)) next.delete(key);
//       else next.add(key);
//       return next;
//     });
//   };

//   const getAnswerText = (r) =>
//     (r.answer || r.transcript || r.studentAnswer || "").toString().trim();

//   const getScoreNumber = (r) => {
//     const n = Number(r.score);
//     return Number.isFinite(n) ? n : null;
//   };

//   // Match by question text (workaround until backend pagination fix is deployed)
//   const rows = useMemo(() => {
//     if (!assessments || !Array.isArray(assessments) || !q) {
//       return [];
//     }

//     const questionText = decodeURIComponent(q);

//     // Match by question text
//     const filtered = assessments.filter((a) => {
//       const assessmentQuestion = a.question || "";
//       // Exact match
//       if (assessmentQuestion === questionText) return true;
//       // Prefix match (first 50 chars)
//       if (assessmentQuestion.slice(0, 50) === questionText.slice(0, 50)) return true;
//       // Normalized match
//       const normalizedAssessment = assessmentQuestion.replace(/\s+/g, " ").trim();
//       const normalizedQuestion = questionText.replace(/\s+/g, " ").trim();
//       if (normalizedAssessment.slice(0, 50) === normalizedQuestion.slice(0, 50)) return true;
//       return false;
//     });

//     return filtered
//       .map((a) => ({
//         timestamp: a.lastModified || a.createdAt || "",
//         score: Number(a.score ?? 0),
//         answer: (a.studentAnswer ?? a.transcript ?? "").toString(),
//         transcript: (a.studentAnswer ?? a.transcript ?? "").toString(),
//         summary: a.summary ?? "",
//         feedback: a.aiResponse ?? a.student_evaluation ?? "",
//         topics: a.topics ?? "",
//         environmentId: a.environmentId ?? null,
//         sessionCode: a.sessionCode ?? a.assessmentId ?? null,
//         experienceId: a.experienceId ?? null,
//       }))
//       .sort((a, b) => String(b.timestamp).localeCompare(String(a.timestamp)));
//   }, [assessments, q]);

//   const loading = assessments === null || assessmentsLoading;

//   const avgScore = useMemo(() => {
//     if (!rows.length) return null;
//     const scored = rows.map((r) => getScoreNumber(r)).filter((n) => typeof n === "number");
//     if (!scored.length) return null;
//     return Math.round(scored.reduce((a, b) => a + b, 0) / scored.length);
//   }, [rows]);

//   const blankCount = useMemo(() => rows.filter((r) => !getAnswerText(r)).length, [rows]);

//   const filtered = useMemo(() => {
//     return rows.filter((r) => {
//       const ans = getAnswerText(r);
//       const score = getScoreNumber(r);

//       if (hideBlank && !ans) return false;
//       if (selectedBin && score != null) {
//         const inBin = score >= selectedBin.min && (score < selectedBin.max || (selectedBin.max === 100 && score === 100));
//         if (!inBin) return false;
//       }
//       if (search && !ans.toLowerCase().includes(search.toLowerCase())) return false;
//       return true;
//     });
//   }, [rows, hideBlank, search, selectedBin]);

//   return (
//     <div className="qaPage">
//       <div className="qaContainer">
//         <Link className="qaBackLink" to="/">
//           ← Back to Dashboard
//         </Link>

//         <div className="qaHeader">
//           <div className="qaHeaderId">Insight ID {insightId || "—"}</div>
//           <div className="qaHeaderQuestion">{q || "(no question provided)"}</div>
//         </div>

//         <div className="qaSection">
//           <div className="qaSectionBody">
//             <ScoreVisualizations
//               rows={rows}
//               getAnswerText={getAnswerText}
//               getScoreNumber={getScoreNumber}
//               selectedBin={selectedBin}
//               setSelectedBin={setSelectedBin}
//               binSize={BIN_SIZE}
//               avgScore={avgScore}
//               blankCount={blankCount}
//             />
//           </div>
//         </div>

//         <div className="qaSection">
//           <div className="qaSectionTitle">Responses ({rows.length} total)</div>

//           <div className="qaToolbar">
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               className="qaSearch"
//               placeholder="Search"
//             />
//             <button
//               className="qaPill qaBlankToggle"
//               onClick={() => setHideBlank((v) => !v)}
//               type="button"
//               aria-pressed={hideBlank}
//             >
//               {hideBlank ? "SHOW BLANKS" : "HIDE BLANKS"}
//             </button>
//           </div>

//           {loading ? (
//             <div className="qaEmpty">Loading answers…</div>
//           ) : rows.length === 0 ? (
//             <div className="qaEmpty">
//               No responses found for this question.
//             </div>
//           ) : (
//             <div className="qaTable">
//               <div className="qaTableHeader">
//                 <div className="qaTh">DATE</div>
//                 <div className="qaTh">NAME</div>
//                 <div className="qaTh">SCORE</div>
//                 <div className="qaTh">ANSWER</div>
//                 <div className="qaTh qaThAction" />
//               </div>

//               {filtered.map((r, idx) => {
//                 const key = `${r.timestamp || ""}-${r.sessionCode || ""}-${idx}`;
//                 const isOpen = expanded.has(key);
//                 const answer = getAnswerText(r);
//                 const isBlank = !answer;
//                 const d = safeDate(r.timestamp);
//                 const topics = splitTopics(r.topics);
//                 const hasDetails = Boolean(r.summary || r.feedback || topics.length);

//                 return (
//                   <div key={key} className="qaTr">
//                     <div className="qaTd qaTdDate">
//                       <div className="qaDateMain">{formatDate(d)}</div>
//                       <div className="qaDateSub">{formatTime(d)}</div>
//                     </div>
//                     <div className="qaTd qaTdName">
//                       <div className="qaNameSub">Anonymous</div>
//                       <div className="qaNameMain">{r.sessionCode || "—"}</div>
//                     </div>
//                     <div className="qaTd qaTdScore">
//                       <div className={scoreBubbleTone(r.score, isBlank)}>
//                         {isBlank ? "—" : `${Math.round(r.score || 0)}%`}
//                       </div>
//                     </div>
//                     <div className="qaTd qaTdAnswer">
//                       <div className={`qaAnswer ${isBlank ? "isBlank" : ""}`}>
//                         {answer || "No response provided"}
//                       </div>
//                       {hasDetails && isOpen && (
//                         <div className="qaDetails">
//                           {r.summary && (
//                             <div className="qaDetailBlock">
//                               <div className="qaDetailLabel">SUMMARY</div>
//                               <div className="qaDetailText">{r.summary}</div>
//                             </div>
//                           )}
//                           {r.feedback && (
//                             <div className="qaDetailBlock">
//                               <div className="qaDetailLabel">AI FEEDBACK</div>
//                               <div className="qaDetailText">{r.feedback}</div>
//                             </div>
//                           )}
//                           {topics.length > 0 && (
//                             <div className="qaDetailBlock">
//                               <div className="qaDetailLabel">TOPICS</div>
//                               <div className="qaTopics">
//                                 {topics.map((t) => (
//                                   <span key={t} className="qaTopic">{t}</span>
//                                 ))}
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                     <div className="qaTd qaTdAction">
//                       {hasDetails ? (
//                         <button
//                           className={`qaPill ${isOpen ? "isActive" : ""}`}
//                           type="button"
//                           onClick={() => toggleExpanded(key)}
//                         >
//                           {isOpen ? "HIDE" : "VIEW"}
//                         </button>
//                       ) : (
//                         <div className="qaNoAction">—</div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}

//               {filtered.length === 0 && (
//                 <div className="qaEmpty">No results match your filters.</div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// src/pages/QuestionAnswersPage.js
import { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useExperiences } from "../context/ExperiencesContext";
import ScoreVisualizations from "../components/answers/ScoreVisualizations";
import Score from "../components/dashboard/Score";
import { AppButton, Panel } from "../components/ui";
import "./QuestionAnswersPage.scss";

function safeDate(ts) {
  if (!ts) return null;
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

function formatDate(d) {
  if (!d) return "—";
  return d.toLocaleDateString(undefined, {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
}

function formatTime(d) {
  if (!d) return "";
  return d.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
}

function splitTopics(t) {
  if (!t) return [];
  if (Array.isArray(t)) return t.map(String).filter(Boolean);
  return String(t)
    .split(/[,|]/g)
    .map((s) => s.trim())
    .filter(Boolean);
}

export default function QuestionAnswersPage() {
  const [params] = useSearchParams();
  const insightId = params.get("insightId") || "";
  const q = params.get("q") || "";

  const { assessments, assessmentsLoading } = useExperiences();

  const [hideBlank, setHideBlank] = useState(true);
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(() => new Set());
  const [selectedBin, setSelectedBin] = useState(null);
  const BIN_SIZE = 20;

  // Scroll to top when component mounts or question changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [insightId, q]);

  const toggleExpanded = (key) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const getAnswerText = (r) =>
    (r.answer || r.transcript || r.studentAnswer || "").toString().trim();

  const getScoreNumber = (r) => {
    const n = Number(r.score);
    return Number.isFinite(n) ? n : null;
  };

  // Match assessments - try insightId first (now that backend pagination is fixed), fall back to question text
  const rows = useMemo(() => {
    if (!assessments || !Array.isArray(assessments)) {
      return [];
    }

    console.log("🔍 QuestionAnswersPage - Matching assessments");
    console.log("  Total assessments loaded:", assessments.length);
    console.log("  insightId from URL:", insightId);
    console.log("  question text:", q);

    let filtered = [];

    // Match by insightId only (backend pagination fix now deployed)
    if (insightId) {
      filtered = assessments.filter((a) => a.insightId === insightId);
      console.log("  ✅ Matches by insightId:", filtered.length);
    }

    // Log sample of matched assessments for debugging
    if (filtered.length > 0) {
      console.log("  📋 Sample matched assessment:", {
        insightId: filtered[0].insightId,
        question: filtered[0].question?.slice(0, 50) + "...",
        score: filtered[0].score,
      });
    }

    return filtered
      .map((a) => ({
        timestamp: a.lastModified || a.createdAt || "",
        score: Number(a.score ?? 0),
        answer: (a.studentAnswer ?? a.transcript ?? "").toString(),
        transcript: (a.studentAnswer ?? a.transcript ?? "").toString(),
        summary: a.summary ?? "",
        feedback: a.aiResponse ?? a.student_evaluation ?? "",
        topics: a.topics ?? "",
        environmentId: a.environmentId ?? null,
        sessionCode: a.sessionCode ?? a.assessmentId ?? null,
        experienceId: a.experienceId ?? null,
        insightId: a.insightId ?? null,
      }))
      .sort((a, b) => String(b.timestamp).localeCompare(String(a.timestamp)));
  }, [assessments, insightId, q]);

  const loading = assessments === null || assessmentsLoading;

  const avgScore = useMemo(() => {
    if (!rows.length) return null;
    const scored = rows.map((r) => getScoreNumber(r)).filter((n) => typeof n === "number");
    if (!scored.length) return null;
    return Math.round(scored.reduce((a, b) => a + b, 0) / scored.length);
  }, [rows]);

  const blankCount = useMemo(() => rows.filter((r) => !getAnswerText(r)).length, [rows]);

  const filtered = useMemo(() => {
    return rows.filter((r) => {
      const ans = getAnswerText(r);
      const score = getScoreNumber(r);

      if (hideBlank && !ans) return false;
      if (selectedBin && score != null) {
        const inBin = score >= selectedBin.min && (score < selectedBin.max || (selectedBin.max === 100 && score === 100));
        if (!inBin) return false;
      }
      if (search && !ans.toLowerCase().includes(search.toLowerCase())) return false;
      return true;
    });
  }, [rows, hideBlank, search, selectedBin]);

  return (
    <div className="qaPage">
      <div className="qaContainer">
        <Link className="qaBackLink" to="/dashboard">
          ← Back to Dashboard
        </Link>

        <div className="qaHeader">
          <div className="qaHeaderId">Insight ID {insightId || "—"}</div>
          <div className="qaHeaderQuestion">{q || "(no question provided)"}</div>
        </div>

        <div className="qaSection">
          <div className="qaSectionBody">
            <ScoreVisualizations
              rows={rows}
              getAnswerText={getAnswerText}
              getScoreNumber={getScoreNumber}
              selectedBin={selectedBin}
              setSelectedBin={setSelectedBin}
              binSize={BIN_SIZE}
              avgScore={avgScore}
              blankCount={blankCount}
            />
          </div>
        </div>

        <div className="qaSection">
          <div className="qaSectionTitle">Responses ({filtered.length})</div>
          <div className="qaToolbar">
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="qaSearch"
              placeholder="Search"
            />
            <AppButton
              className="qaPill qaBlankToggle"
              onClick={() => setHideBlank((v) => !v)}
              type="button"
              kind="secondary"
              aria-pressed={hideBlank}
            >
              {hideBlank ? "SHOW BLANKS" : "HIDE BLANKS"}
            </AppButton>
          </div>

          {loading ? (
            <div className="qaEmpty">Loading answers…</div>
          ) : rows.length === 0 ? (
            <div className="qaEmpty">
              No responses found for this question.
            </div>
          ) : (
            <div className="qaTable app-row-list">
              <div className="qaTableHeader">
                <div className="qaTh">DATE</div>
                <div className="qaTh">NAME</div>
                <div className="qaTh">SCORE</div>
                <div className="qaTh">ANSWER</div>
                <div className="qaTh qaThAction" />
              </div>

              {filtered.map((r, idx) => {
                const key = `${r.timestamp || ""}-${r.sessionCode || ""}-${idx}`;
                const isOpen = expanded.has(key);
                const answer = getAnswerText(r);
                const isBlank = !answer;
                const d = safeDate(r.timestamp);
                const topics = splitTopics(r.topics);
                const hasDetails = Boolean(r.summary || r.feedback || topics.length);

                return (
                  <Panel key={key} className="qaTr" hoverable>
                    <div className="qaTd qaTdDate">
                      <div className="qaDateMain">{formatDate(d)}</div>
                      <div className="qaDateSub">{formatTime(d)}</div>
                    </div>
                    <div className="qaTd qaTdName">
                      <div className="qaNameSub">Anonymous</div>
                      <div className="qaNameMain">{r.sessionCode ? r.sessionCode.slice(0, 4) : "—"}</div>
                    </div>
                    <div className="qaTd qaTdScore">
                      {isBlank ? (
                        <div className="qaScoreEmpty">—</div>
                      ) : (
                        <Score score={Math.round(r.score || 0)} />
                      )}
                    </div>
                    <div className="qaTd qaTdAnswer">
                      <div className={`qaAnswer ${isBlank ? "isBlank" : ""}`}>
                        {answer || "No response provided"}
                      </div>
                      {hasDetails && isOpen && (
                        <div className="qaDetails">
                          {r.summary && (
                            <div className="qaDetailBlock">
                              <div className="qaDetailLabel">SUMMARY</div>
                              <div className="qaDetailText">{r.summary}</div>
                            </div>
                          )}
                          {r.feedback && (
                            <div className="qaDetailBlock">
                              <div className="qaDetailLabel">AI FEEDBACK</div>
                              <div className="qaDetailText">{r.feedback}</div>
                            </div>
                          )}
                          {topics.length > 0 && (
                            <div className="qaDetailBlock">
                              <div className="qaDetailLabel">TOPICS</div>
                              <div className="qaTopics">
                                {topics.map((t) => (
                                  <span key={t} className="qaTopic">{t}</span>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="qaTd qaTdAction">
                      {hasDetails ? (
                        <AppButton
                          className={`qaPill ${isOpen ? "isActive" : ""}`}
                          type="button"
                          kind={isOpen ? "primary" : "secondary"}
                          onClick={() => toggleExpanded(key)}
                        >
                          {isOpen ? "HIDE" : "VIEW"}
                        </AppButton>
                      ) : (
                        <div className="qaNoAction">—</div>
                      )}
                    </div>
                  </Panel>
                );
              })}

              {filtered.length === 0 && (
                <div className="qaEmpty">No results match your filters.</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
